import { useQuery } from 'react-query'
import { get } from 'framework/api/http'

/* Get every recipient (active or inactive) for one Partner + ServiceName report card */
export const getEmailAlertRecipients = async (queryData: any) => {
  const [, partnerId, serviceName] = queryData.queryKey as [
    string,
    string,
    string,
  ]

  const res = await get(
    `/NotificationRecipient/${partnerId}/Recipients?serviceName=${encodeURIComponent(
      serviceName,
    )}`,
  )
  return res.data
}

export const useGetEmailAlertRecipients = (
  partnerId: string | undefined,
  serviceName: string | undefined,
) => {
  return useQuery(
    ['emailAlertRecipients', partnerId, serviceName],
    getEmailAlertRecipients,
    {
      enabled: !!partnerId && !!serviceName,
      refetchOnWindowFocus: false,
    },
  )
}

export default useGetEmailAlertRecipients
